var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,32V18h6l1-6h-7V9c0-2,1.002-3,3-3h3V0c-1,0-3.24,0-5,0c-5,0-7,3-7,8v4H6v6h6v14H18z","fill":"#3B5998","id":"f_1_"}));
}

SocialFacebook.defaultProps = {"enableBackground":"new 0 0 32 32","height":"32px","version":"1.0","viewBox":"0 0 32 32","width":"32px","xmlSpace":"preserve"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
